<template>
    <div class="login-container">
        <div  class="wrapper" :class="{'hide-fireworks': showFireworks}">
            <canvas id="wrapper-canvas" width="1950px" height="900px"></canvas>
        </div>

        <div class="fireworks" :class="{'hide-fireworks': !showFireworks}">
            <canvas id='cas' style="background-color:rgba(0,5,24,1);">浏览器不支持canvas</canvas>
            <div class="city"><img src="@/assets/city.png" alt="" /></div>
            <img src="@/assets/moon.png" alt="" id="moon" />
            <div style="display:none">
                <div class="shape">阖家欢乐</div>
                <div class="shape">心想事成</div>
                <div class="shape">万事如意</div>
                <div class="shape">财源广进</div>
                <div class="shape">福星高照</div>
            </div>
        </div>

        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
            <div>
                <h1>SIM卡管理</h1>
            </div>
            <el-form-item class="el-form-item-defind" prop="accountName">
                <el-input v-model.trim="loginForm.accountName" placeholder="账号" prefix-icon="el-icon-user" size="large"> </el-input>
                <div class="showRememberAccount" v-show="showAccountsPanel">
                    <RememberAccount @func="getAccountFormSon" ></RememberAccount>
                </div>
            </el-form-item>
            <el-form-item prop="pwd">
                <el-input v-model.trim="loginForm.pwd" placeholder="密码" prefix-icon="el-icon-lock" show-password size="large" @keyup.native.enter="handleLogin"></el-input>
            </el-form-item>
            <el-form-item >
                <el-checkbox v-model="rememberMe">记住我</el-checkbox>
            </el-form-item>
            
            <el-form-item class="el-form-item-defind" >
                <el-button type="primary" class="login-btn" @click.prevent = "handleLogin" size="large">登 录</el-button>
            </el-form-item>

            <el-form-item class="el-form-item-defind" >
                <el-popover trigger="hover" class="qrcode-show" >
                    <div style="text-align: center">
                        <p >扫码登录微信公众号</p><br>
                        <img style="width:120px; height: 120px;" src="@/assets/qrCode.png"> 
                    </div>
                    <a slot="reference" >微信公众号链接</a>
                    <a slot="reference" href="http://crm1.519liuliang.com/" target="_blank">旧系统登录</a>
                </el-popover>
            </el-form-item>
        </el-form>


        <el-dialog title="修改密码" :visible.sync="modifyPwdVisible"  width="600px" :show-close="false">
            <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="原密码：">
                    <el-input v-model="modifyPwdForm.oldPwd" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                </el-form-item>
                <el-form-item label="新密码：">
                    <el-input v-model="modifyPwdForm.newPwd" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newPwdAgain">
                    <el-input v-model="modifyPwdForm.newPwdAgain" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="modifyPwd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {login} from '@/api/user.js'
import { mapActions } from "vuex";
import RememberAccount from '@/component/RememberAccount'
import {sysRequest} from '@/api/customizedRequest.js'

export default {
    components: {RememberAccount },
    name: 'login',
    data(){
        var checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };
        return {
            loginForm: {
                accountName: '',
                pwd: ''
            },
            loginRules: {
                accountName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                pwd: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ]
            },

            rememberMe:false,

            //修改密码
            modifyPwdVisible:false,
            modifyPwdTip:'',
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: ''
            },
            pwdRules: {
                newPwdAgain: [
                    {validator: checkPwd, trigger: 'blur'}
                ]
            },
            //修改密码  end
            showFireworks: false,
        }
    },
    methods: {
        ...mapActions("menu", {
            setNickName: "setNickName"
        }),
        getAccountFormSon(data){
            if(data.account.length > 0){
                this.loginForm.accountName = data.account;
                // this.loginForm.pwd = data.password;
            }
        },
        handleLogin(){
            this.$refs.loginForm.validate(valid => {
                if(valid){       
                    login(this.loginForm).then(res => {                     
                        if(res.data.code == 200){
                            var token = res.data.data.token;
                            var id = res.data.data.id; 
                            localStorage.setItem('token', token);
                            localStorage.setItem('id', id);
                            this.$store.state.id = res.data.data.id;
                            this.$store.commit('menu/setToken', localStorage.getItem('token'));
                            this.$store.commit('menu/setId', res.data.data.id);
                            var nickName = res.data.data.nickName;
                            this.setNickName(nickName);
                            this.$router.push('AdminHome');

                            if(this.rememberMe){
                                this.setAutoCompleteData("loginAccounts", this.loginForm.accountName+'/'+this.loginForm.pwd, 8);
                            }
                        }else if(res.data.code == 410){
                            let token = res.data.data.token;
                            let id = res.data.data.id;
                            localStorage.setItem('token', token);
                            this.modifyPwdForm.id = id;
                            this.modifyPwdTip = res.data.message;
                            this.modifyPwdVisible = true;
                        }
                        else if(res.data.code == 400){
                            this.$message.error(res.data.message)
                        }
                    })
                }else{
                    return;
                }
            })
        },

        //修改密码
        modifyPwd(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    sysRequest('sysUser/updatePwd', this.modifyPwdForm, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            let s = '<span style="color: #fd5353;">'+"为保证账户安全，请不要轻易泄露自己的账户及密码。"+'</span>'
                            this.$alert('修改密码成功！请使用新密码重新登录。'+s, '提示', 
                                { confirmButtonText: '确定', 
                                dangerouslyUseHTMLString: true, 
                                callback: action => {
                                  this.modifyPwdVisible = false;
                                  this.$message.success(res.data.message)
                                  window.location.href = window.location;
                                }
                            });
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
                                               
                }
            })
        },

        cancel(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
        },
        //修改密码  end



        /**      圈圈特效        **/ 
        drawCircle(){
            // min and max radius, radius threshold and percentage of filled circles
            var radMin = 5,
              radMax = 125,
              filledCircle = 60, //percentage of filled circles
              concentricCircle = 30, //percentage of concentric circles
              radThreshold = 25; //IFF special, over this radius concentric, otherwise filled
              var wrapperCanvas = document.getElementById("wrapper-canvas");
              wrapperCanvas.width = document.body.clientWidth;
              wrapperCanvas.height = document.body.clientHeight;

            //min and max speed to move
            var speedMin = 0.3,
              speedMax = 2.5;

            //max reachable opacity for every circle and blur effect
            var maxOpacity = 0.6;

            //default palette choice
            var colors = ['52,168,83', '117,95,147', '199,108,23', '194,62,55', '0,172,212', '120,120,120'],
              bgColors = ['52,168,83', '117,95,147', '199,108,23', '194,62,55', '0,172,212', '120,120,120'],
              circleBorder = 10,
              backgroundLine = bgColors[0];
            var backgroundMlt = 0.85;

            //min distance for links
            var linkDist = Math.min(wrapperCanvas.width, wrapperCanvas.height) / 2.4,
              lineBorder = 2.5;

            //most importantly: number of overall circles and arrays containing them
            var maxCircles = 12,
              points = [],
              pointsBack = [];

            //populating the screen
            for (var i = 0; i < maxCircles * 2; i++) points.push(new Circle());
            for (var i = 0; i < maxCircles; i++) pointsBack.push(new Circle(true));

            //experimental vars
            var circleExp = 1,
              circleExpMax = 1.003,
              circleExpMin = 0.997,
              circleExpSp = 0.00004,
              circlePulse = false;

            //circle class
            function Circle(background) {
              //if background, it has different rules
              this.background = (background || false);
              this.x = randRange(-wrapperCanvas.width / 2, wrapperCanvas.width / 2);
              this.y = randRange(-wrapperCanvas.height / 2, wrapperCanvas.height / 2);
              this.radius = background ? hyperRange(radMin, radMax) * backgroundMlt : hyperRange(radMin, radMax);
              this.filled = this.radius < radThreshold ? (randint(0, 100) > filledCircle ? false : 'full') : (randint(0, 100) > concentricCircle ? false : 'concentric');
              this.color = background ? bgColors[randint(0, bgColors.length - 1)] : colors[randint(0, colors.length - 1)];
              this.borderColor = background ? bgColors[randint(0, bgColors.length - 1)] : colors[randint(0, colors.length - 1)];
              this.opacity = 0.05;
              this.speed = (background ? randRange(speedMin, speedMax) / backgroundMlt : randRange(speedMin, speedMax)); // * (radMin / this.radius);
              this.speedAngle = Math.random() * 2 * Math.PI;
              this.speedx = Math.cos(this.speedAngle) * this.speed;
              this.speedy = Math.sin(this.speedAngle) * this.speed;
              var spacex = Math.abs((this.x - (this.speedx < 0 ? -1 : 1) * (wrapperCanvas.width / 2 + this.radius)) / this.speedx),
                spacey = Math.abs((this.y - (this.speedy < 0 ? -1 : 1) * (wrapperCanvas.height / 2 + this.radius)) / this.speedy);
              this.ttl = Math.min(spacex, spacey);
            };

            Circle.prototype.init = function() {
              Circle.call(this, this.background);
            }

            //support functions
            //generate random int a<=x<=b
            function randint(a, b) {
                return Math.floor(Math.random() * (b - a + 1) + a);
              }
              //generate random float
            function randRange(a, b) {
                return Math.random() * (b - a) + a;
              }
              //generate random float more likely to be close to a
            function hyperRange(a, b) {
              return Math.random() * Math.random() * Math.random() * (b - a) + a;
            }

            //rendering function
            function drawCircle(ctx, circle) {
              //circle.radius *= circleExp;
              var radius = circle.background ? circle.radius *= circleExp : circle.radius /= circleExp;
              ctx.beginPath();
              ctx.arc(circle.x, circle.y, radius * circleExp, 0, 2 * Math.PI, false);
              ctx.lineWidth = Math.max(1, circleBorder * (radMin - circle.radius) / (radMin - radMax));
              ctx.strokeStyle = ['rgba(', circle.borderColor, ',', circle.opacity, ')'].join('');
              if (circle.filled == 'full') {
                ctx.fillStyle = ['rgba(', circle.borderColor, ',', circle.background ? circle.opacity * 0.8 : circle.opacity, ')'].join('');
                ctx.fill();
                ctx.lineWidth=0;
                ctx.strokeStyle = ['rgba(', circle.borderColor, ',', 0, ')'].join('');
              }
              ctx.stroke();
              if (circle.filled == 'concentric') {
                ctx.beginPath();
                ctx.arc(circle.x, circle.y, radius / 2, 0, 2 * Math.PI, false);
                ctx.lineWidth = Math.max(1, circleBorder * (radMin - circle.radius) / (radMin - radMax));
                ctx.strokeStyle = ['rgba(', circle.color, ',', circle.opacity, ')'].join('');
                ctx.stroke();
              }
              circle.x += circle.speedx;
              circle.y += circle.speedy;
              if (circle.opacity < (circle.background ? maxOpacity : 1)) circle.opacity += 0.01;
              circle.ttl--;
            }

            //initializing function
            function init() {
              window.requestAnimationFrame(draw);
            }

            //rendering function
            function draw() {

              if (circlePulse) {
                if (circleExp < circleExpMin || circleExp > circleExpMax) circleExpSp *= -1;
                circleExp += circleExpSp;
              }
              var ctxfr = wrapperCanvas.getContext('2d');

              ctxfr.globalCompositeOperation = 'destination-over';
              ctxfr.clearRect(0, 0, wrapperCanvas.width, wrapperCanvas.height); // clear canvas


              ctxfr.save();
              ctxfr.translate(wrapperCanvas.width / 2, wrapperCanvas.height / 2);


              //function to render each single circle, its connections and to manage its out of boundaries replacement
              function renderPoints(ctx, arr) {
                for (var i = 0; i < arr.length; i++) {
                  var circle = arr[i];
                  //checking if out of boundaries
                  if (circle.ttl<0) {}
                  var xEscape = wrapperCanvas.width / 2 + circle.radius,
                    yEscape = wrapperCanvas.height / 2 + circle.radius;
                  if (circle.ttl < -20) arr[i].init(arr[i].background);
                  //if (Math.abs(circle.y) > yEscape || Math.abs(circle.x) > xEscape) arr[i].init(arr[i].background);
                  drawCircle(ctx, circle);
                }
                for (var i = 0; i < arr.length - 1; i++) {
                  for (var j = i + 1; j < arr.length; j++) {
                    var deltax = arr[i].x - arr[j].x;
                    var deltay = arr[i].y - arr[j].y;
                    var dist = Math.pow(Math.pow(deltax, 2) + Math.pow(deltay, 2), 0.5);
                    //if the circles are overlapping, no laser connecting them
                    if (dist <= arr[i].radius + arr[j].radius) continue;
                    //otherwise we connect them only if the dist is < linkDist
                    if (dist < linkDist) {
                      var xi = (arr[i].x < arr[j].x ? 1 : -1) * Math.abs(arr[i].radius * deltax / dist);
                      var yi = (arr[i].y < arr[j].y ? 1 : -1) * Math.abs(arr[i].radius * deltay / dist);
                      var xj = (arr[i].x < arr[j].x ? -1 : 1) * Math.abs(arr[j].radius * deltax / dist);
                      var yj = (arr[i].y < arr[j].y ? -1 : 1) * Math.abs(arr[j].radius * deltay / dist);
                      ctx.beginPath();
                      ctx.moveTo(arr[i].x + xi, arr[i].y + yi);
                      ctx.lineTo(arr[j].x + xj, arr[j].y + yj);
                      var samecolor = arr[i].color == arr[j].color;
                      ctx.strokeStyle = ["rgba(", arr[i].borderColor, ",", Math.min(arr[i].opacity, arr[j].opacity) * ((linkDist - dist) / linkDist), ")"].join("");
                      ctx.lineWidth = (arr[i].background ? lineBorder * backgroundMlt : lineBorder) * ((linkDist - dist) / linkDist); //*((linkDist-dist)/linkDist);
                      ctx.stroke();
                    }
                  }
                }
              }

              renderPoints(ctxfr, points);

              ctxfr.restore();

              window.requestAnimationFrame(draw);
            }

            init();
        },
        /**      圈圈特效     end    **/ 








        /**      烟花特效        **/
        fireworks(){
            
            // min and max radius, radius threshold and percentage of filled circles
            var canvas = document.getElementById("cas");
            var ocas = document.createElement("canvas");
            var octx = ocas.getContext("2d");
            var ctx = canvas.getContext("2d");
            ocas.width = canvas.width = window.innerWidth;
            ocas.height = canvas.height = window.innerHeight;
            var bigbooms = [];
            var lastTime, newTime;
            var blessingTime = new Date();
            var maxRadius = 1 , stars=[];

            window.onload = function(){
                initAnimate()
            }

            function initAnimate(){
                drawBg();

                lastTime = new Date();
                animate();
            }

            
            function animate(){
                ctx.save();
                ctx.fillStyle = "rgba(0,5,24,0.1)";
                ctx.fillRect(0,0,canvas.width,canvas.height);
                ctx.restore();


                newTime = new Date();
                
                if(newTime-lastTime>500){
                    var now = new Date();
                    var random = true;
                    if(now-blessingTime >= 5000){
                        random = false;
                        blessingTime = now;
                    }else{
                        random = true;
                    }
                    
                    var x = getRandom(canvas.width/5 , canvas.width*4/5);
                    var y = getRandom(50 , 200);
                    if(random){
                        var bigboom = new Boom(getRandom(canvas.width/3,canvas.width*2/3) ,2,"#FFF" , {x:x , y:y});
                        bigbooms.push(bigboom)
                    }
                    else {
                        var bigboom = new Boom(getRandom(canvas.width/3,canvas.width*2/3) ,2,"#FFF" , {x:canvas.width/2 , y:200} , document.querySelectorAll(".shape")[parseInt(getRandom(0, document.querySelectorAll(".shape").length))]);
                        bigbooms.push(bigboom)
                    }
                    lastTime = newTime;
                }

                stars.foreach(function(){
                    this.paint();
                })

                drawMoon();

                bigbooms.foreach(function(index){
                    var that = this;
                    if(!this.dead){
                        this._move();
                        this._drawLight();
                    }
                    else{
                        this.booms.foreach(function(index){
                            if(!this.dead) {
                                this.moveTo(index);
                            }
                            else if(index === that.booms.length-1){
                                bigbooms[bigbooms.indexOf(that)] = null;
                            }
                        })
                    }
                });
                
                raf(animate);
            }

            function drawMoon(){
                var moon = document.getElementById("moon");
                var centerX = canvas.width-200 , centerY = 100 , width = 80;
                if(moon && moon.complete){
                    ctx.drawImage(moon , centerX , centerY , width , width )
                }
                else {
                    moon.onload = function(){
                        ctx.drawImage(moon ,centerX , centerY , width , width)
                    }
                }
                var index = 0;
                for(var i=0;i<10;i++){
                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(centerX+width/2 , centerY+width/2 , width/2+index , 0 , 2*Math.PI);
                    ctx.fillStyle="rgba(240,219,120,0.005)";
                    index+=2;
                    ctx.fill();
                    ctx.restore();
                }
                
            }

            

            Array.prototype.foreach = function(callback){
                for(var i=0;i<this.length;i++){
                    if(this[i]!==null) callback.apply(this[i] , [i])
                }
            }

            var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) { window.setTimeout(callback, 1000 / 60); };
            
            canvas.onclick = function(){
                var x = event.clientX;
                var y = event.clientY;
                var bigboom = new Boom(getRandom(canvas.width/3,canvas.width*2/3) ,2,"#FFF" , {x:x , y:y});
                bigbooms.push(bigboom)
            }

            // canvas.addEventLisener("touchstart" , function(event){
            //  var touch = event.targetTouches[0];
            //  var x = event.pageX;
            //  var y = event.pageY;
            //  var bigboom = new Boom(getRandom(canvas.width/3,canvas.width*2/3) ,2,"#FFF" , {x:x , y:y});
            //  bigbooms.push(bigboom)
            // })

            var Boom = function(x,r,c,boomArea,shape){
                this.booms = [];
                this.x = x;
                this.y = (canvas.height+r);
                this.r = r;
                this.c = c;
                this.shape = shape || false;
                this.boomArea = boomArea;
                this.theta = 0;
                this.dead = false;
                this.ba = parseInt(getRandom(80 , 200));
            }
            Boom.prototype = {
                _paint:function(){
                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(this.x,this.y,this.r,0,2*Math.PI);
                    ctx.fillStyle = this.c;
                    ctx.fill();
                    ctx.restore();
                },
                _move:function(){
                    var dx = this.boomArea.x - this.x , dy = this.boomArea.y - this.y;
                    this.x = this.x+dx*0.01;
                    this.y = this.y+dy*0.01;

                    if(Math.abs(dx)<=this.ba && Math.abs(dy)<=this.ba){
                        if(this.shape){
                            this._shapBoom();
                        }
                        else this._boom();
                        this.dead = true;
                    }
                    else {
                        this._paint();
                    }
                },
                _drawLight:function(){
                    ctx.save();
                    ctx.fillStyle = "rgba(255,228,150,0.3)";
                    ctx.beginPath();
                    ctx.arc(this.x , this.y , this.r+3*Math.random()+1 , 0 , 2*Math.PI);
                    ctx.fill();
                    ctx.restore();
                },
                _boom:function(){
                    var fragNum = getRandom(30 , 200);
                    var style = getRandom(0,10)>=5? 1 : 2;
                    var color;
                    if(style===1){
                        color = {
                            a:parseInt(getRandom(128,255)),
                            b:parseInt(getRandom(128,255)),
                            c:parseInt(getRandom(128,255))
                        }
                    }

                    var fanwei = parseInt(getRandom(300, 400));
                    for(var i=0;i<fragNum;i++){
                        if(style===2){
                            color = {
                                a:parseInt(getRandom(128,255)),
                                b:parseInt(getRandom(128,255)),
                                c:parseInt(getRandom(128,255))
                            }
                        }
                        var a = getRandom(-Math.PI, Math.PI);
                        var x = getRandom(0, fanwei) * Math.cos(a) + this.x;
                        var y = getRandom(0, fanwei) * Math.sin(a) + this.y; 
                        var radius = getRandom(0 , 2)
                        var frag = new Frag(this.x , this.y , radius , color , x , y );
                        this.booms.push(frag);
                    }
                },
                _shapBoom:function(){
                    var that = this;
                    putValue(ocas , octx , this.shape , 5, function(dots){
                        var dx = canvas.width/2-that.x;
                        var dy = canvas.height/2-that.y;
                        for(var i=0;i<dots.length;i++){
                            var color = {a:dots[i].a,b:dots[i].b,c:dots[i].c}
                            var x = dots[i].x;
                            var y = dots[i].y;
                            var radius = 1;
                            var frag = new Frag(that.x , that.y , radius , color , x-dx , y-dy);
                            that.booms.push(frag);
                        }
                    })
                }
            }

            function putValue(canvas , context , ele , dr , callback){
                context.clearRect(0,0,canvas.width,canvas.height);
                var img = new Image();
                if(ele.innerHTML.indexOf("img")>=0){
                    img.src = ele.getElementsByTagName("img")[0].src;
                    imgload(img , function(){
                        context.drawImage(img , canvas.width/2 - img.width/2 , canvas.height/2 - img.width/2);
                        var dots = getimgData(canvas , context , dr);
                        callback(dots);
                    })
                }
                else {
                    var text = ele.innerHTML;
                    context.save();
                    var fontSize =200;
                    context.font = fontSize+"px 宋体 bold";
                    context.textAlign = "center";
                    context.textBaseline = "middle";
                    context.fillStyle = "rgba("+parseInt(getRandom(128,255))+","+parseInt(getRandom(128,255))+","+parseInt(getRandom(128,255))+" , 1)";
                    context.fillText(text , canvas.width/2 , canvas.height/2);
                    context.restore();
                    var dots = getimgData(canvas , context , dr);
                    callback(dots);
                }
            }

            function imgload(img , callback){
                if(img.complete){
                    callback.call(img);
                }
                else {
                    img.onload = function(){
                        callback.call(this);
                    }
                }
            }

            function getimgData(canvas , context , dr){
                var imgData = context.getImageData(0,0,canvas.width , canvas.height);
                context.clearRect(0,0,canvas.width , canvas.height);
                var dots = [];
                for(var x=0;x<imgData.width;x+=dr){
                    for(var y=0;y<imgData.height;y+=dr){
                        var i = (y*imgData.width + x)*4;
                        if(imgData.data[i+3] > 128){
                            var dot = {x:x , y:y , a:imgData.data[i] , b:imgData.data[i+1] , c:imgData.data[i+2]};
                            dots.push(dot);
                        }
                    }
                }
                return dots;
            }

            function getRandom(a , b){
                return Math.random()*(b-a)+a;
            }


            
            function drawBg(){
                for(var i=0;i<100;i++){
                    var r = Math.random()*maxRadius;
                    var x = Math.random()*canvas.width;
                    var y = Math.random()*2*canvas.height - canvas.height;
                    var star = new Star(x , y , r);
                    stars.push(star);
                    star.paint()
                }

            }

            var Star = function(x,y,r){
                this.x = x;this.y=y;this.r=r;
            }
            Star.prototype = {
                paint:function(){
                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(this.x , this.y , this.r , 0 , 2*Math.PI);
                    ctx.fillStyle = "rgba(255,255,255,"+this.r+")";
                    ctx.fill();
                    ctx.restore();
                }
            }

            var focallength = 250;
            var Frag = function(centerX , centerY , radius , color ,tx , ty){
                this.tx = tx;
                this.ty = ty;
                this.x = centerX;
                this.y = centerY;
                this.dead = false;
                this.centerX = centerX;
                this.centerY = centerY;
                this.radius = radius;
                this.color = color;
            }

            Frag.prototype = {
                paint:function(){
                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(this.x , this.y , this.radius , 0 , 2*Math.PI);
                    ctx.fillStyle = "rgba("+this.color.a+","+this.color.b+","+this.color.c+",1)";
                    ctx.fill()
                    ctx.restore();
                },
                moveTo:function(index){
                    this.ty = this.ty+0.3;
                    var dx = this.tx - this.x , dy = this.ty - this.y;
                    this.x = Math.abs(dx)<0.1 ? this.tx : (this.x+dx*0.1);
                    this.y = Math.abs(dy)<0.1 ? this.ty : (this.y+dy*0.1);
                    if(dx===0 && Math.abs(dy)<=80){
                        this.dead = true;
                    }
                    this.paint();
                }
            }
            /**      烟花特效     end    **/     
        },

        /**  烟花特效播放时间  **/
        fireworksTime(){
            let timeBucket = [
                {start: '2020-01-24 20:00:00', end: '2020-01-25 06:00:00',},
                {start: '2020-01-25 20:00:00', end: '2020-01-26 06:00:00',},
                {start: '2020-01-26 20:00:00', end: '2020-01-27 06:00:00',},
                {start: '2020-01-27 20:00:00', end: '2020-01-28 06:00:00',},
                {start: '2020-01-28 20:00:00', end: '2020-01-29 06:00:00',},
                {start: '2020-01-29 20:00:00', end: '2020-01-30 06:00:00',},
                {start: '2020-01-30 20:00:00', end: '2020-01-31 06:00:00',}
            ]

            let now = new Date();
            for(let i=0; i<timeBucket.length; i++){
                if(now>=new Date(timeBucket[i].start) && now<=new Date(timeBucket[i].end)){
                    return true;
                }
            }

            return false;
        },
        /**  烟花特效播放时间  end **/
    },

    created(){
        this.showFireworks = this.fireworksTime();

        /**  临时使用  **/
        localStorage.removeItem("currentTheme");
        localStorage.removeItem("currentNavItemColor");
        /****/
    },

    mounted(){
        if(this.showFireworks){
            this.fireworks();
            window.onresize = () => {
                return (() => {
                    this.fireworks();
                })();
            };
        }else{
            this.drawCircle();
            window.onresize = () => {
                return (() => {
                    this.drawCircle();
                })();
            };
        }
        
    },

    updated(){

    },


    computed: {
        formatDateGetOnlyDay(date) {
            return {
                cardState:this.$store.state.menu.cardState,
                dataLevel:this.$store.state.menu.cardDataLevel
            }

        },

        showAccountsPanel: function () {
            let account = this.getAutoCompleteData('loginAccounts');
            if(account!=null && account!=undefined && account.length > 0){
                if(this.loginForm.accountName.length > 0){
                    return false;
                }else{
                    return true;
                }
            }else{
                return false;
            }
        }
    },
}
</script>

<style lang="less" scoped>
    *{
        box-sizing: border-box;
    }

    .hide-fireworks{
        display: none;
    }

    .login-container, .wrapper{
        -ms-overflow-style: none; 
        overflow: -moz-scrollbars-none; 
    }

    .wrapper::-webkit-scrollbar, .login-container::-webkit-scrollbar {
        display: none; 
    }

    .login-container {
        position: relative;
        height: 100%;
        background-size: cover;

        .wrapper{
            background: #000;
        }

        .fireworks{
            height: 100%; 
            overflow:hidden;

            .city{
                width:100%;
                position:fixed;
                bottom: 0px;
                z-index: 100;

                img{width: 100%;}
            }
        }

        


        .logo-on-loginPage{
            height: 75px;
            position: absolute;
            top: 60px;
            left: 80px;
            display: flex;

            h2{
                display: inline-block;
                margin-left: 20px;
                line-height: 75px;
                font-size:32px;
                color: #4c4c4c;
                letter-spacing: 2px;
            }

            img{
                height: 60px;
                margin-top: 8px;
                display: inline-block;
            }
        }

        .tips{
            position: absolute;
            top: 350px;
            left: 150px;
            font-size: 68px;
            color: #fff;
            letter-spacing: 5px;
        }

        .login-form {
            position: absolute;
            top: 20%;
            right: 15%;
            width: 400px;
            height: 450px;
            padding: 50px 50px 0 50px;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 10px;
            box-shadow: 0px 0px 15px #b5b5b5;

            h1 {
                text-align: center;
                color: #128bf1;
                font-size: 26px;
                letter-spacing: 1px;
                margin-bottom: 45px;
            }
            .login-btn {
                width: 100%;
            }


            .el-form-item-defind{margin-bottom: 38px;}
        }


        .el-input__inner {
            background-color: rgba(255, 255, 255, 0.5);
        }

        .showRememberAccount{
            position: absolute;
            box-sizing: border-box;
            width: 100%;
            background: #f7f7f7;
            border: 1px solid #dcdfe6;
            border-radius: 5px;
            z-index: 9;
        }



        .qrcode-show{
            display: inline-block;
            width: 100%;

            a:last-child{
                position: absolute;
                right: 0;
            }
        }





        @media screen and (max-width: 480px) {
            .logo{
                height: 75px;
                position: absolute;
                top: 20px;
                left: 20px;
                display: block;

                h2{
                    display: block;
                    margin-left: 10px;
                    line-height: 75px;
                    font-size:20px;
                    color: #fff;
                    letter-spacing: 2px;
                }

                img{
                    height: 30px;
                    margin-top: 8px;
                    display: inline-block;
                }
            }

            .tips{
                display:none;
            }

            .login-form {
                position: absolute;
                top: 25%;
                left: 20px;
                width: 250px;
                height: 450px;
                padding: 20px 20px 0 20px;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 10px;
                box-shadow: 0px 0px 15px #b5b5b5;

                h1 {
                    text-align: center;
                    color: #128bf1;
                    font-size: 26px;
                    letter-spacing: 1px;
                    margin-bottom: 45px;
                }
                .login-btn {
                    width: 100%;
                }


                .el-form-item-defind{margin-bottom: 38px;}
            }
        }


    }

</style>

